import { render, staticRenderFns } from "./UCheckbox.vue?vue&type=template&id=a960dd28&scoped=true"
import script from "./UCheckbox.vue?vue&type=script&lang=js"
export * from "./UCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UCheckbox.vue?vue&type=style&index=0&id=a960dd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a960dd28",
  null
  
)

export default component.exports